import {courseStats} from '../../../constants/url';
import axios from 'axios';

async function getDataDashboard(cwid: string, token: any) {
  try {
    const response = await axios.get(`${courseStats}?cwid=${cwid}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
    return false;
  }
}

export default getDataDashboard;
